import { useDispatch, useSelector } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";

import { type UnknownAction } from "@reduxjs/toolkit";

import { type RootState } from "@/rootReducer";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type TypedDispatch<T> = ThunkDispatch<T, any, UnknownAction>;
export const useAppDispatch = useDispatch.withTypes<TypedDispatch<RootState>>();
export const useAppSelector = useSelector.withTypes<RootState>();
